import { BrowserRouter } from 'react-router-dom'
import { UbiRoutes } from 'routes/Routes'
import { queryClient } from 'config/reactQuery'
import { QueryClientProvider } from '@tanstack/react-query'
import { UserProvider } from 'shared/contexts/user/user'
import { TenantProvider, ThemeProvider, ToastProvider } from 'shared/hooks'

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <UserProvider>
          <TenantProvider>
            <ThemeProvider>
              <ToastProvider>
                <UbiRoutes />
              </ToastProvider>
            </ThemeProvider>
          </TenantProvider>
        </UserProvider>
      </BrowserRouter>
    </QueryClientProvider>
  )
}

export default App
